import { useQuery } from "@tanstack/react-query";
import {
  getAnnouncementSummaries,
  type PatientAnnouncementSummary,
} from "@/api/settings.api";

export function usePatientAnnouncementSummaries(patientIds: string[]) {
  const key = [...new Set(patientIds.filter(Boolean))].sort().join(",");
  return useQuery({
    queryKey: ["patient-announcement-summaries", key],
    queryFn: () => getAnnouncementSummaries(patientIds),
    enabled: patientIds.length > 0,
    staleTime: 30_000,
  });
}

export type { PatientAnnouncementSummary };
